import { api } from '../../../services/api/client';

export interface Signal {
  id: string;
  instrument: string;
  direction: 'buy' | 'sell';
  entry_price: number;
  take_profit?: number | null;
  stop_loss?: number | null;
  note?: string;
  image_url?: string;
  image_link?: string;
  audience: 'all' | 'vip';
  is_published: boolean;
  created_at: string;
  updated_at: string;
}

export interface SignalPayload {
  instrument: string;
  direction: 'buy' | 'sell';
  entry_price: number;
  take_profit?: number | null;
  stop_loss?: number | null;
  note?: string;
  image_url?: string;
  image_link?: string;
  audience: 'all' | 'vip';
  is_published: boolean;
}

export async function adminListSignals(): Promise<Signal[]> {
  const { data } = await api.get<Signal[]>('/admin/signals');
  return data;
}
export async function adminCreateSignal(p: SignalPayload): Promise<Signal> {
  const { data } = await api.post<Signal>('/admin/signals', p);
  return data;
}
export async function adminUpdateSignal(id: string, p: Partial<SignalPayload>): Promise<Signal> {
  const { data } = await api.put<Signal>(`/admin/signals/${id}`, p);
  return data;
}
export async function adminDeleteSignal(id: string): Promise<any> {
  const { data } = await api.delete(`/admin/signals/${id}`);
  return data;
}
export async function fetchMemberSignals(): Promise<Signal[]> {
  const { data } = await api.get<Signal[]>('/member/signals');
  return data;
}
export async function fetchPublicSignal(id: string): Promise<Signal> {
  const { data } = await api.get<Signal>(`/public/signals/${id}`);
  return data;
}
